export const PREFIX = 'tech-theme'
export const DOT_PREFIX = `.${PREFIX}`
